export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13600.d3dfe055.jpg";